module.exports = __webpack_public_path__ + "static/media/calendar-icon.ad55492f.svg";